export default __webpack_public_path__ + "d13fe587e964e361cadafcc7b67a350b.png";